import React, { useState, useEffect, useRef } from "react";
import {
  Heart,
  CircleUser,
  ShoppingCart,
  User,
  LogOut,
  Search,
  X
} from "lucide-react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import WishlistModal from "../Wishlist/WishlistModal";
import LoginPromptModal from "../LoginModal/LoginPromptModal";
import { useCartWishlist } from "../../app/CartWishlistContext";
import API from "../../app/api";
import { IoLogoWhatsapp } from "react-icons/io";
import searchicon from "../../assets/icons/Searchicon.svg";
import Desktoplogo from "../../assets/images/logo-dark.png";
import noImage from "../../assets/images/no-image.jpg";
import { getProductPdpUrl } from "../../utils/url.utils";
import "../../assets/styles/components/Navbars/Megamenunav.css";


const OtherTopnav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { countData, getCartWishlistCount } = useCartWishlist();
  const [showMegaMenu, setShowMegaMenu] = useState(false);
  const [showWishlist, setShowWishlist] = useState(false);
  const [showUserPopup, setShowUserPopup] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [disableHover, setDisableHover] = useState(false);
  const [query, setQuery] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [chatData, setChatData] = useState(null);
  const userWrapperRef = useRef(null);
  const inputRef = useRef(null);
  const closeTimer = useRef(null);
  const isLoginPage = location.pathname === "/login";
  const [activeIndex, setActiveIndex] = useState(-1);
  const visibleResults = Array.isArray(searchData)
    ? searchData.slice(0, 8)
    : [];

  useEffect(() => {
    if (activeIndex < 0) return;

    const el = document.querySelector(".active-item");
    if (el) {
      el.scrollIntoView({ block: "nearest" });
    }
  }, [activeIndex]);


  // ------------------ Fetch Chat Support ------------------ //
  useEffect(() => {
    const fetchChatSupport = async () => {
      try {
        const res = await API.get("/support/chat");
        if (res.data.status === 200) {
          setChatData(res.data.data);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchChatSupport();
  }, []);

  // ------------------ Session Check ------------------ //
  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);
  }, []);

  // ------------------ Close User Popup ------------------ //
  useEffect(() => {
    const handleClickOutside = () => {
      setShowMegaMenu(false);
      setActiveMenu(null);
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // ------------------ Handle Search ------------------ //

  useEffect(() => {
    if (!query.trim()) {
      setSearchData([]);
      return;
    }
    const delayDebounce = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await API.get(`search?q=${query}`);
        if (res.data.status === 200) {
          setSearchData(res.data.data.products || []);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }, 300); // ⏱ debounce

    return () => clearTimeout(delayDebounce);
  }, [query]);


  // ------------------ Focus Input & Prevent Scroll ------------------ //

  useEffect(() => {
    if (showSearch) {
      inputRef.current?.focus();
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showSearch]);

  // ------------------ Cart / Wishlist Click ------------------ //

  const handleCartClick = (e) => {
    const token = localStorage.getItem("token");
    if (!token) {
      e.preventDefault();
      navigate("/login", { state: { redirectTo: "/cart" } });
    }
  };

  const handleWishlistClick = () => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login", { state: { from: location.pathname } });
    } else {
      setShowWishlist(true);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userName");
    setIsLoggedIn(false);
    setShowUserPopup(false);
    getCartWishlistCount();
    navigate("/");
  };

  const handleUserClick = (e) => {
    e.stopPropagation();
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    } else {
      setShowUserPopup((prev) => !prev);
    }
  };

  const clearSearch = () => {
    setQuery("");
    setSearchData([]);
    setShowSearch(false);
  };

  // ------------------ MegaMenu Hover ------------------ //

  const handleMouseEnter = () => {
    if (disableHover) return;
    clearTimeout(closeTimer.current);
    setShowMegaMenu(true);
  };

  const handleMouseLeave = () => {
    if (disableHover) return;
    closeTimer.current = setTimeout(() => setShowMegaMenu(false), 200);
  };

  const handleItemClick = () => {
    clearTimeout(closeTimer.current);
    setDisableHover(true);
    setShowMegaMenu(false);
    setTimeout(() => setDisableHover(false), 200);
  };

  // ------------------ Highlight Function ------------------ //

  const highlightText = (text, query) => {
    if (!query) return text;

    const parts = text.split(new RegExp(`(${query})`, "gi"));

    return parts.map((part, i) =>
      part.toLowerCase() === query.toLowerCase()
        ? <mark key={i}>{part}</mark>
        : part
    );
  };

  //------- Search data --------//

  const words = [
    "Search for carpets",
    "Search for bathmats",
    "Search for dustbins",
    "Search for organisers"
  ];

  const [index, setIndex] = useState(0);
  const [animate, setAnimate] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate(false);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % words.length);
        setAnimate(true);
      }, 400);

    }, 2500);

    return () => clearInterval(interval);
  }, []);

  // Api Call  //

  const [menuData, setMenuData] = useState([]);
  const [offers, setOffers] = useState(null);
  const [menuImage, setMenuImage] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);
  const [loadingMenu, setLoadingMenu] = useState(true);

  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const res = await API.get("menu/categories");
        // console.log("MENU API:", res.data); 
        if (res?.data?.status === 200) {
          setMenuData(res.data.data?.categories || []);
          setOffers(res.data.data?.offers || null);
        } else {
          console.warn("Menu API failed:", res.data);
        }
      } catch (err) {
        console.error("Menu API error:", err);
      } finally {
        setLoadingMenu(false);
      }
    };
    fetchMenu();
  }, []);

//------- search product list data --------//

const [searchTerm, setSearchTerm] = useState("");
const products = [
  {
    id: 1,
    title: "Royal Nomadic Modern Abstract",
    image:
      "https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2c-img/EnvogueImages/product/8907831207542/8907831207542.jpg",
    newPrice: "₹2565",
    oldPrice: "₹2850",
    off: "10% OFF",
  },
  {
    id: 2,
    title: "Luxury Designer Carpet",
    image:
      "https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2c-img/EnvogueImages/product/8907831243052/8907831243052.jpg",
    newPrice: "₹3565",
    oldPrice: "₹4200",
    off: "15% OFF",
  },
  {
    id: 3,
    title: "Modern Floor Rug",
    image:
      "https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2c-img/EnvogueImages/product/8907831243106/8907831243106.jpg",
    newPrice: "₹1999",
    oldPrice: "₹2500",
    off: "20% OFF",
  },
  {
    id: 4,
    title: "Classic Handmade Carpet",
    image:
      "https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2c-img/EnvogueImages/product/8907831276081/8907831276081.jpg",
    newPrice: "₹4599",
    oldPrice: "₹5200",
    off: "12% OFF",
  },
];

// ---------------- FILTER DATA ---------------- //

const filteredData = products.filter((item) =>
  item.title
    .toLowerCase()
    .includes(searchTerm.toLowerCase())
);

  return (
    <>
      <nav className="navheader">
        <div className="wrapper">
          <div className="logo">
              <Link to="/"> <img src={Desktoplogo} alt="" width={"160px"} style={{ marginTop: "-9px" }} /> </Link>
          </div>
          {/* Radio buttons */}
          <input type="radio" name="slider" id="menu-btn" />
          <input type="radio" name="slider" id="close-btn" />
          <ul className="nav-links">
            {menuData.map((category) => {
              const defaultImage = noImage;

              return (
                <li
                  key={category.id}
                  onMouseEnter={() => {
                    setActiveMenu(category.id);
                    setMenuImage(category.media || defaultImage);
                    handleMouseEnter();
                  }}
                  onMouseLeave={() => {
                    handleMouseLeave();
                    setMenuImage(null);
                  }}
                >
                  {/* CATEGORY */}
                  <Link
                    to={category.actionLink}
                    className={`desktop-item ${activeMenu === category.id ? "active" : ""
                      }`}
                    onClick={() => {
                      setActiveMenu(category.id);
                      handleItemClick();
                    }}
                  >
                    {category.name.toUpperCase()}
                  </Link>

                  {/* MOBILE */}
                  <input type="checkbox" id={`menu-${category.id}`} />
                  <label htmlFor={`menu-${category.id}`} className="mobile-item">
                    {category.name}
                  </label>

                  <div
                    className={`mega-box ${showMegaMenu && activeMenu === category.id ? "show" : ""
                      }`}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    <div className="content">
                      {/*LEFT IMAGE */}
                      {(menuImage || category?.media) && (
                        <div className="row row-margin">
                          <img
                            src={
                              menuImage ||
                              category.media
                            }
                            alt={category.name}
                            onError={(e) => (e.target.src = defaultImage)}
                            style={{ width: "320px", height: "246px" }}
                          />
                        </div>
                      )}

                      {/* SUBCATEGORIES */}
                      <div className="row">
                        <ul className="mega-links w0001">
                          {category.subcategories?.map((sub) => (
                            <li key={sub.id}>
                              <Link
                                to={`${category.actionLink}${sub.actionLink}`}
                                onClick={handleItemClick}
                                onMouseEnter={() => {
                                  setMenuImage(
                                    sub.media || category.media || defaultImage
                                  );
                                }}
                              >
                                {sub.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </li>
              );
            })}

            {/* OFFERS */}
            {offers && (
              <li>
                <Link to={offers.action_url} className="desktop-item">
                  <span className="blink-offer">
                    <strong>{offers.name}</strong>
                  </span>
                </Link>
              </li>
            )}
          </ul>
          <label htmlFor="menu-btn" className="btn menu-btn">
            <i className="fas fa-bars"></i>
          </label>
          <div className="logo">
            <div className="nav-actions">
              <div className="search-wrapper-box"> 
              <div className="searchbuttonbox" style={{ marginRight:"1px"}}  onClick={() => setShowSearch(!showSearch)} >
                   <Search size={24} strokeWidth={1} color="#090909" style={{ cursor:"pointer"}} />
              </div>
               
                 {/* DROPDOWN INPUT */}
                  {/* {showSearch && (
                    <div className="search-dropdown">
                      <div style={{ backgroundColor:"#FFF", width:"100%"}}>  
                      <button className="search-close-btn" onClick={() => setShowSearch(false)} >
                              <X size={16} />
                      </button>
                      <input
                        type="text"
                        placeholder="Search..."
                        className="search-input"
                      />
                      <span className="searchicons">
           
                         <i className="bi bi-search"></i>
                          </span>
                      </div> 

                



                     <div className="Autocomplete-search"> 
                      <div className="box001">  
                       <p style={{ color:"#6b6a6a"}}> 235 Results </p>
                       <Link to="/"> View All </Link>
                      </div>
             
                      <div className="row"> 
                         <div className="col-md-3">
                              <div className="product-box-section">
                                 <div className="imgbox">
                                    <img src="https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2c-img/EnvogueImages/product/8907831207542/8907831207542.jpg" alt=""/>
                                  </div>
                                  <div className="heading-section"> 
                                   <h2><Link to="/"> Royal Nomadic Modern Abstract </Link> </h2>
                                     <div class="detialsprice">
                                        <span class="new">₹2565</span>
                                        <span class="old">₹2850</span>
                                        <span class="off">10% OFF</span>
                                     </div>
                                  </div>
                               </div>
                           </div>
                        
                           <div className="col-md-3">
                              <div className="product-box-section">
                                 <div className="imgbox">
                                    <img src="https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2c-img/EnvogueImages/product/8907831207542/8907831207542.jpg" alt=""/>
                                  </div>
                                  <div className="heading-section"> 
                                   <h2><Link to="/"> Royal Nomadic Modern Abstract </Link> </h2>
                                     <div class="detialsprice">
                                        <span class="new">₹2565</span>
                                        <span class="old">₹2850</span>
                                        <span class="off">10% OFF</span>
                                     </div>
                                  </div>
                          
                               </div>
                           </div>

                              <div className="col-md-3">
                              <div className="product-box-section">
                                 <div className="imgbox">
                                    <img src="https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2c-img/EnvogueImages/product/8907831207542/8907831207542.jpg" alt=""/>
                                  </div>
                                 <div className="heading-section"> 
                                   <h2><Link to="/"> Royal Nomadic Modern Abstract </Link> </h2>
                                     <div class="detialsprice">
                                        <span class="new">₹2565</span>
                                        <span class="old">₹2850</span>
                                        <span class="off">10% OFF</span>
                                     </div>
                                  </div>
                               </div>
                           </div>

                           <div className="col-md-3">
                              <div className="product-box-section">
                                 <div className="imgbox">
                                    <img src="https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2c-img/EnvogueImages/product/8907831207542/8907831207542.jpg" alt=""/>
                                  </div>
                                <div className="heading-section"> 
                                   <h2><Link to="/"> Royal Nomadic Modern Abstract </Link> </h2>
                                     <div class="detialsprice">
                                        <span class="new">₹2565</span>
                                        <span class="old">₹2850</span>
                                        <span class="off">10% OFF</span>
                                     </div>
                                  </div>
                               </div>
                           </div>
                        </div>
                      </div>
                    </div>
                  )} */}

{/* DROPDOWN INPUT */}
{showSearch && (
  <div className="search-dropdown">
    <div
      style={{
        backgroundColor: "#FFF",
        width: "100%",
        position: "relative",
      }}
    >

      {/* CLOSE BUTTON */}
      <button
        className="search-close-btn"
        onClick={() => setShowSearch(false)}
      >
        <X size={16} />
      </button>

      {/* SEARCH INPUT */}
      <input
        type="text"
        placeholder="Search product..."
        className="search-input"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      {/* SEARCH ICON */}
      <span className="searchicons">
        <i className="bi bi-search"></i>
      </span>
    </div>

    {/* SEARCH RESULT */}
    {searchTerm !== "" && (
      <div className="Autocomplete-search">
        <div className="box001">
          <p style={{ color: "#6b6a6a" }}>
            {filteredData.length} Results
          </p>
         <Link  to="/all-products"   // redirect page path
            onClick={() => setQuery("")}
          >
            View All
          </Link>
        </div>

        <div className="row">
          {filteredData.length > 0 ? (
            filteredData.map((item) => (
              <div className="col-md-3" key={item.id}>
                <div className="product-box-section">
                  {/* IMAGE */}
                  <div className="imgbox">
                    <img
                      src={item.image}
                      alt={item.title}
                    />
                  </div>

                  {/* CONTENT */}
                  <div className="heading-section">
                    <h2>
                      <Link to="/">
                        {item.title}
                      </Link>
                    </h2>

                    <div className="detialsprice">
                      <span className="new">
                        {item.newPrice}
                      </span>
                      <span className="old">
                        {item.oldPrice}
                      </span>
                      <span className="off">
                        {item.off}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12">
              <p
                style={{
                  textAlign: "center",
                  padding: "20px",
                }}
              >
                No Data Found
              </p>
            </div>
          )}

        </div>
      </div>
    )}
  </div>
)}  
 {/* THE END */}

               </div>

              {/* User Icon */}
              <div
                ref={userWrapperRef}
                className="user-click-wrapper user-click"
                onClick={handleUserClick}
               >
                <span className="top-paddings">
                  {localStorage.getItem("userName")?.split(" ")[0] || ""}
                </span>

                {/* User Icon */}
                <CircleUser
                  strokeWidth={1}
                  color="#090909"
                  size={25}
                  style={{ cursor: "pointer" }}
                />

                {/* Dropdown */}
                {showUserPopup && (
                  <>
                    <div className="popup-triangle"></div>

                    <div className="user-popup">
                      <div className="popup-item">
                        <Link
                          to="/accounts?ref=topnav"
                          onClick={() => setShowUserPopup(false)}
                        >
                          <i className="bi bi-person" style={{ fontSize: "20px", marginRight: 8 }}></i>
                          My Profile
                        </Link>
                      </div>

                      <div className="popup-item">
                        <Link
                          to="/accounts/orders?ref=topnav"
                          onClick={() => setShowUserPopup(false)}
                        >
                          <i className="bi bi-box-seam" style={{ fontSize: "16px", marginRight: 8 }}></i>
                          Orders
                        </Link>
                      </div>

                      <div className="popup-item">
                        <Link
                          to="/accounts/addresses?ref=topnav"
                          onClick={() => setShowUserPopup(false)}
                        >
                          <i className="bi bi-geo-alt" style={{ fontSize: "20px", marginRight: 8 }}></i>
                          Saved Addresses
                        </Link>
                      </div>

                      <div
                        className="popup-item Logout-bg"
                        onClick={() => {
                          handleLogout();
                        }}
                      >
                        <i className="bi bi-box-arrow-left" style={{ fontSize: "19px", marginRight: 8 }}></i>
                        Logout
                      </div>
                    </div>
                  </>
                )}
              </div>

              {/* Wishlist */}
              <div title="Wishlist" onClick={handleWishlistClick} style={{ cursor: "pointer" }}>
                <Heart
                  strokeWidth={1}
                  size={25}
                  title="Wish List"
                />
                <span className="wishlist-badge" style={{ right: "27px", top: "4px", color: "black" }}>
                  <span style={{ position: 'relative', top: '1px' }}> {countData?.wishlist_count ?? ''}</span>
                </span>
              </div>

              {/* Cart */}
              <div title="Cart" style={{ marginLeft: "4px" }}>
                <Link to="/cart" onClick={handleCartClick}>
                  <ShoppingCart
                    onClick={handleCartClick}
                    strokeWidth={1}
                    title="Shopping Cart"
                    size={25}
                    style={{ cursor: "pointer" }}
                  />
                  <span className="wishlist-badge" style={{ right: "-8px", top: "4px", color: "black" }}>
                    <span style={{ position: 'relative', top: '1px' }}>{countData?.cart_count ?? ''} </span>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Wishlist & Login Modals */}
      {showWishlist && <WishlistModal onClose={() => setShowWishlist(false)} />}
      {showLoginPrompt && !isLoginPage && <LoginPromptModal onClose={() => setShowLoginPrompt(false)} />}

      {/* Fullscreen Search */}
      {/* {showSearch && (
        <div className="search-overlay" onClick={clearSearch}>
          <div className="search-modal-other" onClick={(e) => e.stopPropagation()}>
            <div className="d-flex position-relative">
              <input
                ref={inputRef}
                className="form-control border-0 input_home"
                placeholder="WHAT ARE YOU LOOKING FOR?"
                value={query}
                onChange={(e) => setQuery(e.target.value.replace(/[^a-zA-Z0-9 ]/g, "").replace(/^\s+/, ""))}
                onKeyDown={(e) => {
                  if (!visibleResults.length && e.key !== "Enter") return;

                  //  DOWN
                  if (e.key === "ArrowDown") {
                    e.preventDefault();
                    setActiveIndex((prev) =>
                      prev < visibleResults.length - 1 ? prev + 1 : 0
                    );
                  }

                  // UP
                  if (e.key === "ArrowUp") {
                    e.preventDefault();
                    setActiveIndex((prev) =>
                      prev > 0 ? prev - 1 : visibleResults.length - 1
                    );
                  }

                  //  ENTER
                  if (e.key === "Enter") {
                    e.preventDefault();

                    const trimmed = query.trim();

                    if (activeIndex >= 0 && visibleResults[activeIndex]) {
                      const item = visibleResults[activeIndex];
                      clearSearch();
                    } else if (trimmed) {
                      navigate(`/search?q=${encodeURIComponent(trimmed)}`);
                      clearSearch();
                    }
                  }
                }}
              />
              <button
                type="button"
                className="btn btn-dark button_search"
                disabled={!query.trim()}
                onClick={() => {
                  const trimmed = query.trim();
                  if (!trimmed) return;
                  navigate(`/search?q=${encodeURIComponent(trimmed)}`);
                  clearSearch();
                }}
              >
                <Search strokeWidth={1.25} />
              </button>


            </div>
          </div>
        </div>
      )} */}

      {/* Floating WhatsApp */}
      {chatData && (
        <a
          href={`https://api.whatsapp.com/send?phone=${chatData.phone}&text=${chatData.text}`}
          className="floating-whatsapp"
          target="_blank"
          rel="noopener noreferrer"
        >
          <IoLogoWhatsapp className="whatsapp-icon" />
        </a>
      )}
    </>
  );
};
export default OtherTopnav;